 // Tablica przechowująca dane z accordionów
    let faqData = [];
    // Tablica przechowująca wyniki wyszukiwania
    let filteredFaqData = [];

    // Funkcja pobierająca wszystkie elementy z klasą "section-faq"
    function getFaqSections() {
    faqData = [];
    const faqSections = document.querySelectorAll('.section-faq');

    // Iteracja przez elementy i pobranie elementów z klasą "page-accordion"
    faqSections.forEach((section, index) => {
    const accordion = section.querySelector('.page-accordion');

    if (accordion) {
    const wrappers = accordion.querySelectorAll('.accordion__wrapper');

    wrappers.forEach((wrapper, wrapperIndex) => {
    const button = wrapper.querySelector('button');
    const body = wrapper.querySelector('.accordion__body');

    if (button && body) {
    faqData.push({
    title: button.textContent.trim(),
    description: body.textContent.trim()
});
}
});
}
});

    console.log('Zebrane dane FAQ:', faqData);
}

    // Wywołanie funkcji przy przeładowaniu strony
    document.addEventListener('DOMContentLoaded', getFaqSections);

    // Funkcja do wyświetlania wpisanego słowa w elemencie #FaqSearchInput
    function displayFaqSearch() {
    document.querySelectorAll('.section-faq').forEach(section => section.classList.add('hide'));
    const input = document.getElementById('FaqInput');
    const output = document.getElementById('FaqSearchInput');
    const resultsContainer = document.querySelector('.accordion__container-custom--results');
    const noResultsContainer = document.querySelector('.faqNoResults');
    const resultsWrapper = document.querySelector('.faqResults');

    if (input && output) {
    output.textContent = `"${input.value}"`;
    filterFaqData(input.value);
    generateFaqResults();
} else {
    console.warn('Brak elementu FaqInput lub FaqSearchInput');
}

    if (resultsContainer) {
    resultsContainer.classList.add('is-visible');
} else {
    console.warn('Brak elementu .accordion__container-custom--results');
}

    if (filteredFaqData.length === 0) {
    noResultsContainer?.classList.add('is-visible');
    resultsWrapper?.classList.remove('is-visible');
} else {
    resultsWrapper?.classList.add('is-visible');
    noResultsContainer?.classList.remove('is-visible');
}
}

    // Funkcja filtrująca wyniki na podstawie wpisanego słowa
    function filterFaqData(searchTerm) {
    filteredFaqData = faqData.filter(faq =>
        faq.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        faq.description.toLowerCase().includes(searchTerm.toLowerCase())
    );
    console.log('Filtrowane dane FAQ:', filteredFaqData);
}

    // Funkcja zamykająca wyniki wyszukiwania
    function closeResult() {
    document.querySelectorAll('.section-faq').forEach(section => section.classList.remove('hide'));
    const resultsContainer = document.querySelector('.accordion__container-custom--results');
    const input = document.getElementById('FaqInput');

    if (resultsContainer) {
    resultsContainer.classList.remove('is-visible');
} else {
    console.warn('Brak elementu .accordion__container-custom--results');
}

    if (input) { accordion__title-custom
    input.value = '';
} else {
    console.warn('Brak elementu FaqInput');
}
}

    // Funkcja do generowania wyników FAQ w elemencie .page-accordion
    function generateFaqResults() {
    const accordionContainer = document.querySelector('.page-accordion');

    if (!accordionContainer) {
    console.warn('Brak elementu .page-accordion');
    return;
}

    // Czyścimy istniejące wyniki przed dodaniem nowych
    accordionContainer.innerHTML = '';

    filteredFaqData.forEach(faq => {
    const wrapper = document.createElement('div');
    wrapper.classList.add('accordion__wrapper', 'accordion-custom__wrapper');

    const button = document.createElement('button');
    button.classList.add('accordion__title', 'accordion__title-custom');
    button.textContent = faq.title;

    const body = document.createElement('div');
    body.classList.add('accordion__body', 'rte', 'accordion__bodyFaq');
    body.textContent = faq.description;
    body.style.display = 'none';

    button.addEventListener('click', () => {
    button.classList.toggle('accordion-is-open');
    body.style.display = body.style.display === 'none' ? 'block' : 'none';
});

    wrapper.appendChild(button);
    wrapper.appendChild(body);
    accordionContainer.appendChild(wrapper);
});
}

